<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useAccount } from 'dashboard/composables/useAccount';
import { useFocusConversationQueue } from 'dashboard/composables/useFocusConversationQueue';

const { t } = useI18n();
const { accountScopedRoute } = useAccount();
const { exitToList } = useFocusConversationQueue();

const hubRoute = computed(() => accountScopedRoute('focus_hub'));
</script>

<template>
  <section
    class="flex flex-1 flex-col items-center justify-center gap-4 px-6 text-center"
    data-testid="focus-queue-empty"
  >
    <div
      class="flex size-16 items-center justify-center rounded-full bg-n-iris-9/15 text-n-iris-11"
      aria-hidden="true"
    >
      <span class="i-ri-check-double-line size-8" />
    </div>
    <div class="max-w-sm">
      <h2 class="text-xl font-extrabold text-n-slate-12">
        {{ t('CHAT_LIST.FOCUS_QUEUE.EMPTY_TITLE') }}
      </h2>
      <p class="mt-1 text-[15px] text-n-slate-11">
        {{ t('CHAT_LIST.FOCUS_QUEUE.EMPTY_BODY') }}
      </p>
    </div>
    <div class="flex flex-wrap items-center justify-center gap-2">
      <button
        type="button"
        class="inline-flex h-9 items-center rounded-full bg-n-slate-12 px-4 text-[14px] font-bold text-n-solid-1 hover:bg-n-slate-11"
        data-testid="focus-queue-empty-list"
        @click="exitToList"
      >
        {{ t('CHAT_LIST.FOCUS_QUEUE.EMPTY_BACK_LIST') }}
      </button>
      <RouterLink
        :to="hubRoute"
        class="inline-flex h-9 items-center rounded-full px-4 text-[14px] font-bold text-n-slate-12 hover:bg-n-alpha-2"
        data-testid="focus-queue-empty-hub"
      >
        {{ t('CHAT_LIST.FOCUS_QUEUE.EMPTY_BACK_HUB') }}
      </RouterLink>
    </div>
  </section>
</template>
